import React from 'react';
import {
  ExpandableMenu,
  EllipsisMenuButton,
  MenuList,
  MenuItem,
} from '@grnhse/seedling/lib/birch/components/expandable_menu';
import { withLocalePrefix } from 'shared/utils/translation';
import { useRediscoveryApplication } from 'talent_matching/talent_rediscovery/hooks/use_rediscovery_applications';
import styled from 'styled-components';
import Tokens from '@grnhse/seedling/lib/birch/tokens';

const t = withLocalePrefix('talent_matching.rediscovery.table.actions');

const Wrapper = styled.div`
  padding-top: ${Tokens.spacing['1']};
  height: 100%;
`;

type RediscoveryRowActionsProps = {
  applicationId: number;
};

const RediscoveryRowActions = ({
  applicationId,
}: RediscoveryRowActionsProps) => {
  const { application } = useRediscoveryApplication(applicationId);

  if (!application) {
    return null;
  }

  const handleWrapperClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const handleViewCandidate = () => {
    // Placeholder - will be implemented in future
  };

  const handleAddToJob = () => {
    // Placeholder - will be implemented in future
  };

  return (
    <Wrapper onClick={handleWrapperClick} onMouseUp={handleWrapperClick}>
      {/* @ts-expect-error - TS2322 */}
      <ExpandableMenu dangerouslyBypassScrollLock>
        <EllipsisMenuButton aria-label={t('actions')} />
        <MenuList>
          <MenuItem onSelect={handleViewCandidate} disabled>
            {t('view_candidate')}
          </MenuItem>
          <MenuItem onSelect={handleAddToJob} disabled>
            {t('add_to_job')}
          </MenuItem>
        </MenuList>
      </ExpandableMenu>
    </Wrapper>
  );
};

export default RediscoveryRowActions;
